import { defineStore } from "pinia";
import { IParamsNps, IUserNpsStore } from "./types";
import { EStepsPesquisa } from "@/features/shared/PesquisaNPS/types";

export const idStore = "userPesquisaNps";

export const usePesquisaNpsStore = defineStore(idStore, {
  state: (): IUserNpsStore => ({
    params: {
      nota: undefined,
      comentario: "",
      campanhaId: "",
      cliente: "",
      tipoCampanha: 0,
      exibirCampanha: false,
      step: EStepsPesquisa.escolherNota,
      telefone: "",
      aceitaContato: false,
      isWhatsapp: false
    },
    botaoNpsVisivel: false
  }),
  actions: {
    setNota(value: number | undefined): void {
      this.params.nota = value;
    },
    setComentario(value: string): void {
      this.params.comentario = value;
    },
    setBotaoNpsVisivel(value: boolean): void {
      this.botaoNpsVisivel = value;
    }
  },
  getters: {
    obterCampanhaParams(): IParamsNps {
      return this.params;
    }
  }
});
